<template>
    <span>{{Math.abs(params.value)}} {{currency}}</span>
</template>

<script>
    export default {
        name: 'CellRendererValue',
        computed: {
            currency() {
                if (this.params.data.currency)
                    return this.params.data.currency;
                return this.$store.state.currency;
            }
        }
    }
</script>
